/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { qreq } from "../../../shared/qrequest";
import Alert from "../../Alert";
import BaseCom from "../../BaseCom";
import L from "../../Lang";
import Tick from "../../Tick";

export default class GooglePay extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            info: {
                processType: 'gp',
            }
        }
        this.containerRef = React.createRef();
    }

    async componentDidMount() {
        await this.getSettings();
        this.setState({ info: { ...this.state.info, cardHolderName: this.props.session.firstName + ' ' + this.props.session.lastName } });
        setTimeout(() => {
            this.load();
        }, 500);
    }

    load = async () => {
        try {
            let j = await qreq.postAsync('/api/merchant/details', this.props.session);
            if (!j.item) { // error out
                this.alert(j.errorMessage);
                return;
            }

            // TODO: Validate google pay enabled

            this.setState({ loaded: true });

            let script = document.createElement('script');
            script.src = 'https://pay.google.com/gp/p/js/pay.js';
            script.async = true;
            script.onload = () => {


                setTimeout(() => {


                    this.client = new window.google.payments.api.PaymentsClient({ environment: 'PRODUCTION' }); // 'PRODUCTION' or 'TEST'



                    const button = this.client.createButton({ onClick: this.buttonClick });
                    this.containerRef.current.appendChild(button);

                }, 500);



            };
            document.head.appendChild(script);

        }
        catch (e) {
            console.error(e);
        }


    }

    buttonClick = (e) => {
        let _self = this;

        const baseRequest = {
            apiVersion: 2,
            apiVersionMinor: 0
        };

        const tokenizationSpecification = {
            type: 'PAYMENT_GATEWAY',
            parameters:
            {
                'gateway': 'paradigmpay',
                'gatewayMerchantId': '3352176248133416859'
            }
        };

        const allowedCardNetworks = ["AMEX", "DISCOVER", "INTERAC", "JCB", "MASTERCARD", "VISA"];
        const allowedCardAuthMethods = ["PAN_ONLY", "CRYPTOGRAM_3DS"];

        const baseCardPaymentMethod = {
            type: 'CARD',
            parameters: {
                allowedAuthMethods: allowedCardAuthMethods,
                allowedCardNetworks: allowedCardNetworks
            }
        };

        const cardPaymentMethod = Object.assign(
            {},
            baseCardPaymentMethod,
            {
                tokenizationSpecification: tokenizationSpecification
            }
        );
        const paymentDataRequest = Object.assign({}, baseRequest);
        paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
        paymentDataRequest.merchantInfo = {
            merchantId: '3352176248133416859', // TODO: Source from Config
            merchantName: 'Paradigm Services Inc' // TODO: Source from Config
        };

        paymentDataRequest.transactionInfo = {
            displayItems: [
                {
                    label: "Subtotal",
                    type: "SUBTOTAL",
                    price: String(this.props.session.amount),
                },
                {
                    label: "Tax",
                    type: "TAX",
                    price: String(this.props.session.tax),
                }
            ],
            countryCode: 'US',
            currencyCode: "USD",
            totalPriceStatus: "FINAL",
            totalPrice: String(this.props.session.total),
            totalPriceLabel: "Total"
        }


        this.client.loadPaymentData(paymentDataRequest)
            .then(function (e) {

                _self.pay(e);
            })
            .catch(function (err) {

                alert(err);
            });
    }

    pay = async (e) => {
        let token = e.paymentMethodData.tokenizationData.token;
        console.log("Token sent", token);

        let info = { ...this.state.info };
        info.processType = 'gp';
        info.amount = this.props.session.amount;
        info.totalTax = this.props.session.totalTax;
        info.sid = this.props.session.sid;
        info.payToken = token;

        this.setState({ submitting: true });
        try {
            let j = await qreq.postAsync('/api/payment/process', info);
            if (j.item)
                this.props.onSuccess(j.item);
            else
                this.props.onError(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    change = () => {
        this.setState({ info: { ...this.state.info } });
    }

    render() {
        return <div>
            <div className="row">
                <div className="col-md-12">
                    <h2>Google Pay</h2>
                    <div className="text-center" ref={this.containerRef}></div>
                    {this.state.error && <Alert type="danger">{this.state.error}</Alert>}
                </div>
            </div>
            <div className="d-grid my-2">
                <button type="button" className="btn btn-lg" onClick={this.props.onCancel}><L>Select a different Payment Method</L></button>
            </div>
        </div>;
    }
}